'use client'

import { Box, styled } from '@mui/material'

export const StyledPageNav = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  padding: theme.spacing(0),
  position: 'relative',
  maxWidth: '1366px',
  margin: '0 auto',

  '>.content-wrapper': {
    //backgroundColor: `${theme.palette.primary.dark} !important`,
    maxWidth: '1024px',
    alignItems: 'center',

    '.blue': {
      border: '2px solid white',
    },
    '.MuiButton-root': {
      svg: {
        fontSize: '1.25rem'
      }
    }
  },
}))
